import { css } from '@emotion/react'
import { memo, useCallback, useState } from 'react'
import { updatePortalState } from '../../../../state/state.layout'
import IconButton from '../../../Buttons/IconButton'
import { usePortalStateSelector } from '../../../Hooks/usePortalState'
import CollapseArrowDown from '../../../Icons/ArrowCollapseDown'
import ExpandArrowUp from '../../../Icons/ArrowExpandUp'
import { palette } from '../../../styles/colors'
import { COMPONENT_HEIGHTS } from '../../../theme'

const EXPANDED_DIVISION = 50

const iconButtonStyles = css({
    position: 'absolute',
    top: 0,
    right: 0,
    height: COMPONENT_HEIGHTS.availableSpaceControlBar,
    marginLeft: 2,
    marginRight: 2,
    '& .mfc-button': {
        transform: 'scale(0.8)',
    },
})
const expandIconStyles = css({
    color: palette.contrastIcons,
})

const ExpandButton = memo(() => {
    const division = usePortalStateSelector('division')
    const [previousDivision, setPreviousDivision] = useState(division)
    const canExpand = !division || division > EXPANDED_DIVISION
    const Icon = canExpand ? ExpandArrowUp : CollapseArrowDown

    const onClick = useCallback(() => {
        if (division !== EXPANDED_DIVISION) {
            updatePortalState({ division: EXPANDED_DIVISION })
            setPreviousDivision(division)
        } else {
            updatePortalState({ division: previousDivision })
        }
    }, [division, previousDivision])

    if (division < EXPANDED_DIVISION) return null

    return (
        <div css={iconButtonStyles}>
            <IconButton
                title={canExpand ? 'Expand Lower Panel' : 'Shrink Lower Panel'}
                onClick={onClick}
            >
                <Icon css={expandIconStyles} size={1} filled={true} />
            </IconButton>
        </div>
    )
})

export default ExpandButton
